var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Payment Customer"}},[_c('hr'),_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Waiting"}},[_c('div',{staticClass:"con-tab-ejemplo"},[_c('waiting')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }